import { render, staticRenderFns } from "./EditEmployeeLeftSide.vue?vue&type=template&id=b0ff2fd2&"
import script from "./EditEmployeeLeftSide.vue?vue&type=script&lang=js&"
export * from "./EditEmployeeLeftSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports